import React from 'react';
import { Grid, FormControl, InputLabel, TextareaAutosize } from '@mui/material';
import styled, { inputImages, inputStyles, inputNumber, inputNumbers } from '../../Utils/inputChanges';

const TextareaComponent = ({ label, name, value, onChange, isDesktop }) => (
    <Grid item xs={12} md={6}>
        <Grid container alignItems="center" spacing={1}>
            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                <InputLabel htmlFor={name}>{label}:</InputLabel>
            </Grid>
            <Grid item xs>
                <FormControl fullWidth>
                    <TextareaAutosize
                        id={name}
                        name={name}
                        value={value}
                        onChange={onChange}
                        style={{
                            width: '45%',
                            height: '20px',
                            borderRadius: '4px',
                            border: '1px solid #000',
                            ...styled.input
                        }}
                    />
                </FormControl>
            </Grid>
        </Grid>
    </Grid>
);

export default TextareaComponent;
